import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Event, NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CartCustomerService } from '@parts-catalog/services/cart.customer.service';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import * as globals from '@reusable/services/globals';
import { RoutePartsService } from '@reusable/services/route-parts/route-parts.service';
import { UsersService } from '@reusable/services/users/users.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { fromEvent, of, merge } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']

})
export class AppComponent implements OnInit {
  appTitle = 'سبيرو';
  pageTitle = '';
  message: any;
  isConnected: Observable<boolean>;
  firstConnection = false;
  loading: boolean;

  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private meta: Meta,
    private httpClient: HttpClient,
    private toastr: ToastrService,
    private user: UsersService,
    translate: TranslateService,
    private cartService: CartCustomerService,
    private watchStorage: WatchStorageService
  ) {
    translate.setDefaultLang('ar');
    translate.use('ar');
    this.isConnected = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    );
    this.isConnected.subscribe((data: any) => {
      if (data) {
        if (this.firstConnection) {
          this.firstConnection = false;
          // this.toastr.info('تم استعادة الاتصال بالانترنت');
        }
      } else {
        this.firstConnection = true;
        // this.toastr.error('يرجى التحقق من اتصالك بالانترنت');
      }
    });
    router.events.subscribe((event: Event): void => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (event instanceof NavigationEnd) {
        this.loading = false;
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if (event.urlAfterRedirects.indexOf('/team/') !== -1) {
          this.meta.updateTag({ name: 'viewport', content: 'initial-scale=0, shrink-to-fit=no' });
        } else {
          this.meta.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no' });
        }
        const allowedPaths = [
          'login',
          'request',
          'packages',
          'contact-us',
          'about-us',
          'faq',
          'privacy-policy',
          'terms-and-conditions',
          'payment-methods',
          '/customers/'
        ];
      }
      window.scrollTo(0, 0);
    });
    localStorage.removeItem('cart');
    this.watchStorage.setItem('cartChange', true);
    this.cartService.setupCart();
  }

  pingServer() {
    return this.httpClient.head(`${globals.domain}/core/misc/last-update-dates/`)
      .pipe(map(
        () => true,
        () => false
      ));
  }

  changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length) {
        return this.title.setTitle(this.appTitle);
      }
      // Extract title from parts;
      this.pageTitle = routeParts.map(part => part.title).reduce((partA, partI) => `${partA} > ${partI}`);
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }
}